import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Component({
  selector: 'app-shop-page',
  templateUrl: './shop-page.component.html',
  styleUrls: ['./shop-page.component.css']
})
export class ShopPageComponent implements OnInit {
  public availableWorks: any;
  public shopMode: string;

  constructor(private restApi: RestApiService, private gs: GoogleAnalyticsService) { }

  ngOnInit() {
    this.initShopPage();
  }

  private async initShopPage(): Promise<any> {
    this.setShopMode('original');
    // const availableWorksJSON = await this.getAvailableWorks();
    // this.availableWorks = availableWorksJSON.data;
  }

  public setShopMode(state: string) {
    this.shopMode = state;
    this.gs.event('view_gallery', 'engagement', 'click', state);
  }

}
